import React from 'react';

import { CountrysideMain } from '../../components/countryside/Main/Main';
import { CountrysideHeader } from '../../components/countryside/Header/Header';
import { FiltersPanel } from '../../components/countryside/FiltersPanel/FiltersPanel';
import { CountrysideFiltersTabsContainer } from '../countryside/CountrysideFiltersTabsContainer/CountrysideFiltersTabsContainer';
import { CountrysideFiltersContainer } from '../countryside/CountrysideFiltersContainer/CountrysideFiltersContainer';
import { RecommendationsContainer } from '../RecommendationsContainer';
import { CountrysideVillagesContainer } from '../countryside/VillagesContainer/VillagesContainer';
import { CountrysideReviewsContainer } from '../countryside/ReviewsContainer/ReviewsContainer';
import { CountrysideMagazineContainer } from '../countryside/CountrysideMagazineContainer/CountrysideMagazineContainer';
import { GeoSwitcherWrapperContainer } from '../GeoSwitcherContainer';

export const CountrysideHomeContainer = () => (
  <CountrysideMain>
    <GeoSwitcherWrapperContainer />
    <CountrysideHeader>
      <FiltersPanel>
        <CountrysideFiltersTabsContainer />
        <CountrysideFiltersContainer />
      </FiltersPanel>
    </CountrysideHeader>
    <RecommendationsContainer />
    <CountrysideVillagesContainer />
    <CountrysideReviewsContainer />
    <CountrysideMagazineContainer />
  </CountrysideMain>
);
